module.exports = __webpack_public_path__ + "static/media/samsung-awesome-is-for-everyone-2020.341fd431.jpg";